import { render, staticRenderFns } from "./BaseUploadImage.vue?vue&type=template&id=2bda36d6&"
import script from "./BaseUploadImage.vue?vue&type=script&lang=js&"
export * from "./BaseUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports